export const APPS = [
  {
    id: "remedio",
    name: "Remedio",
    icon: "💊",
    tagline: "Care, organised.",
    status: "available",
    statusLabel: "Available",
    statusColor: "#1A9A60",
    accent: "#6D3FE0",
    platform: "Android",
    category: "Health & Wellness",
    developer: "Nismay Studios",
    desc: "Remedio is a simple and thoughtful medicine reminder app designed to help individuals and families manage daily medication schedules. With scheduled reminders, medicine photographs, offline support and family connectivity, everyday medication management becomes easier and more organised.",
    features: [
      { icon: "⏰", title: "Smart Medicine Reminders", desc: "Set medicine names, dosages, schedules and days. Get timely reminders with sound and vibration." },
      { icon: "📴", title: "Offline Access", desc: "Locally stored medicine info and scheduled reminders keep working without an internet connection." },
      { icon: "👨‍👩‍👧", title: "Family Connectivity", desc: "Connect family members and coordinate medicine schedules together. Private by default, shared only when you choose." },
      { icon: "☁️", title: "Cloud Synchronisation", desc: "Sync medicine information with your account and access it across supported devices." },
      { icon: "✨", title: "Simple & Accessible", desc: "A clean, straightforward interface made for users of every age group." },
    ],
    screenshots: [
      { src: "/assets/remedio/login.jpeg", label: "Sign in" },
      { src: "/assets/remedio/medicines.jpeg", label: "My medicines" },
      { src: "/assets/remedio/edit.jpeg", label: "Add reminders" },
      { src: "/assets/remedio/family.jpeg", label: "Family sharing" },
    ],
    cta: { label: "Get it on Android", href: "https://play.google.com/store/apps/details?id=YOUR_PACKAGE_ID" }, // TODO: replace
    disclaimer: "Remedio is a medication organisation and reminder tool. It does not provide medical advice, prescribe medicines or replace guidance from healthcare professionals.",
  },
    {
    id: "nismay-browser",
    name: "Nismay Browser",
    icon: "🧭",
    tagline: "Private browsing, Tor built in.",
    status: "available",
    statusLabel: "Available",
    statusColor: "#1A9A60",
    accent: "#D4900A",
    platform: "Windows",
    category: "Browser",
    developer: "Nismay Studios",
    desc: "Nismay Browser is a private browser for Windows that sends every tab through its own Tor circuit. It blocks ads and trackers, saves no history, cookies or logins, and needs no accounts or setup. Android is coming soon.",
    features: [
      { icon: "🧅", title: "Tor Built In", desc: "Every tab goes through Tor on its own circuit, always on, with nothing to configure." },
      { icon: "🔄", title: "NEW ID", desc: "One click clears your tabs and cookies and gets you a fresh Tor circuit." },
      { icon: "🧹", title: "Nothing Saved", desc: "No history, cookies or logins are stored. No accounts and no telemetry." },
      { icon: "🛡️", title: "Ad & Tracker Blocking", desc: "Blocks ads and trackers using EasyList and EasyPrivacy, updated through Tor." },
      { icon: "🔒", title: "Safer Browsing", desc: "Upgrades http to https, blocks Google sign-in, and has three security levels." },
      { icon: "🕵️", title: "Reduced Fingerprinting", desc: "Blocks canvas reads and hides hardware, battery and Bluetooth details." },
    ],
    screenshots: [], // add e.g. { src: "/assets/nismay-browser/home.png", label: "Tor connected" }
    ctas: [
      {
        label: "Download for Windows",
        href: "https://github.com/imnismay/Nismay-Browser/releases",
      },
      { label: "Android coming soon", disabled: true },
    ],
    disclaimer: "Nismay Browser is private, not anonymous. It hides your IP address, but websites may still recognise your browser by its fingerprint. For the strongest anonymity, use Tor Browser. Nismay Browser is not made by or affiliated with the Tor Project. The Windows installer is not yet code-signed, so SmartScreen may show an \"unknown publisher\" warning: click More info, then Run anyway.",
  },
];